module.exports = __webpack_public_path__ + "img/case19-二所.4f89d260.png";